export default "<div>\n    \n    <div data-dojo-attach-point=\"transportWidgetContainer\"></div>\n</div>"